import * as React from 'react';
import Card from './Card';
import '../css/reward-tile.sass';
import { HatType } from './Hat';
import Anchor from './Anchor';

interface RewardTileProps {
  name?: string;
  value: string;
  valueLabel?: string;
  image: string;
  message?: string;
  detailsLinkLabel?: string;
  detailsLinkUrl?: string;
  available?: boolean;
  hat?: HatType[];
  id: string;
}

export default function RewardTile(props: RewardTileProps) {
  const { valueLabel = 'PTS', detailsLinkLabel = 'Learn More' } = props;
  return (
    <div id={props.id} className="reward-tile">
      <Card hat={props.hat}>
        <div className="tile-header">
          {props.name && <div className="name">{props.name}</div>}
          <div className={`value ${props.available ? 'available' : ''}`}>
            {props.value}
            <br />
            {valueLabel}
          </div>
        </div>
        <div className="image">
          <img src={props.image} alt="" />
        </div>
        {props.message && <div className="message">{props.message}</div>}
        {props.detailsLinkUrl && (
          <div className="link">
            <Anchor
              href={props.detailsLinkUrl}
              id={`${props.id}-${detailsLinkLabel.replace(/[^\w]/g, '')}`}
              arialabel={`${detailsLinkLabel} in ${props.name}`}
              forward
            >
              {detailsLinkLabel}
            </Anchor>
          </div>
        )}
      </Card>
    </div>
  );
}
